import { createFileRoute, redirect } from '@tanstack/react-router'
import { LazyMotion, domAnimation, MotionConfig } from 'motion/react'
import { CanvasPage } from '@/components/pages/CanvasPage'
import { getSession } from '@/lib/auth-client'
import { prefetchLibraryModels } from '@/lib/canvas/utils/prefetchCanvasData'

export const Route = createFileRoute('/canvas/$id')({
  beforeLoad: async ({ location }) => {
    // Start model prefetch immediately — runs in parallel with auth check
    prefetchLibraryModels()

    try {
      const session = await getSession()
      if (!session?.data?.user) {
        throw redirect({ to: '/login', search: { redirect: location.pathname } })
      }
    } catch (e) {
      if (e instanceof Error && 'to' in (e as unknown as Record<string, unknown>)) throw e
      throw redirect({ to: '/login', search: { redirect: location.pathname } })
    }
  },
  component: CanvasRoute,
})

function CanvasRoute() {
  const { id } = Route.useParams()
  return (
    <LazyMotion features={domAnimation}>
      <MotionConfig reducedMotion="user">
        <div className="h-screen w-screen bg-background text-foreground overflow-hidden">
          <CanvasPage key={id} />
        </div>
      </MotionConfig>
    </LazyMotion>
  )
}
